import { FC } from 'react';
import { EmployeeType } from '../../../../../../store/api/employees-api';
import s from './employee-profile-settings.module.css';
import { useLang } from '../../../../../../hooks/use-lang';
import { useInputLangStore } from '../../../../../../store/use-input-lang-store';
import { Avatar } from '../../../../../../components/avatar/avatar';
import { Button } from '../../../../../../components/button/button';
import { Card } from '../../../../../../components/card/card';
import { Container } from '../../../../../../components/container/container';
import { Input } from '../../../../../../components/input/input';
import { MaskedInput } from '../../../../../../components/input/masked-input';
import { Label } from '../../../../../../components/label/label';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { LangTextArea } from '../../../../../../features/lang-textarea/lang-textarea';
import { phoneMask } from '../../../../../../helpers/regexp';

interface Props {
  employee: Partial<EmployeeType>;
  handleUpdateEmployee: (data: Partial<EmployeeType>) => void;
  handleSave: () => void;
  handleUploadImage: (file: File[]) => void;
  isLoading?: boolean;
  isChanged: boolean;
}

export const EmployeeProfileSettings: FC<Props> = (props) => {
  const { handleSave, handleUpdateEmployee, employee, handleUploadImage, isLoading,isChanged } = props;
  const { t, getLocale } = useLang();
  const { language } = useInputLangStore();

  const name = `${getLocale(employee?.name, language)} ${getLocale(employee?.surname, language)}`;

  return (
    <Card className={s.feature} title={`1. ${t('Профиль сотрудника')}`} withLang>
      <div className={s.base}>
        <Avatar
          name={name}
          size="lg"
          className={s.avatar}
          onChange={handleUploadImage}
          img={employee.profile?.avatar?.normal}
        />
        <div className={s.name}>
          <span className={s.fio}>{name}</span>
          <span className={s.tags}>{employee.tags?.map((item) => item.value).join(' | ')}</span>
        </div>
      </div>
      <Container>
        <Label>{t('Личные данные')}</Label>
        <div className={s.inputs}>
          <LangInput
            placeholder={t('Имя')}
            value={employee.name}
            disabled
            onChange={(e) => handleUpdateEmployee({ name: e })}
          />
          <LangInput
            placeholder={t('Фамилия')}
            value={employee.surname}
            disabled
            onChange={(e) => handleUpdateEmployee({ surname: e })}
          />
          <LangInput
            placeholder={t('Отчество')}
            value={employee.patronymic}
            name="patronymic"
            onChange={(e) => handleUpdateEmployee({ patronymic: e })}
          />
          <MaskedInput
            placeholder={t('Телефон')}
            name="phone"
            value={employee.profile?.phone}
            onChange={(e) => handleUpdateEmployee({ profile: { ...employee.profile, phone: e } })}
            mask={phoneMask}
          />
          <Input
            placeholder={t('Электронный ящик')}
            name="email"
            value={employee.profile?.email}
            onChange={(e) =>
              handleUpdateEmployee({
                profile: { ...employee.profile, email: e.currentTarget.value },
              })
            }
          />
          <LangInput
            placeholder={t('Отображаемая должность')}
            value={employee.profile?.display_title}
            name="display_title"
            onChange={(e) =>
              handleUpdateEmployee({
                profile: { ...employee.profile, display_title: e },
              })
            }
          />
          <LangTextArea
            placeholder={t('Дополнительная информация')}
            className={s.textarea}
            name="extra"
            value={employee.profile?.description}
            onChange={(e) =>
              handleUpdateEmployee({ profile: { ...employee.profile, description: e } })
            }
          />
        </div>
      </Container>
      <div className={s.controls}>
        <Button variant="secondary" size="lg" hrefBack>
          {t('Назад')}
        </Button>
        <Button size="lg" onClick={handleSave} disabled={isLoading || !isChanged}>
          {t('Сохранить')}
        </Button>
      </div>
    </Card>
  );
};
